import { Outlet } from 'react-router-dom';
import { TenantProvider } from '@/auth/TenantContext';
import { RequireTenant } from '@/auth/RequireTenant';

/**
 * Top-level authenticated layout (spec 0013): provides tenant context and gates
 * on membership (loading / load-error / create-workspace onboarding). The app
 * shell itself lives under `WorkspaceLayout` (`/:workspaceSlug`), so this layer
 * wraps both the root redirect and the workspace subtree via <Outlet/>.
 */
export function ShellLayout() {
  return (
    <TenantProvider>
      <RequireTenant>
        <Outlet />
      </RequireTenant>
    </TenantProvider>
  );
}
